module.exports = __webpack_public_path__ + "static/media/iconTransportActive.acd3b411.svg";